import omit from 'lodash/omit'
import { AnswerInput } from '__generatedTypes__/globalTypes'
import { findOneQuestion_findOneQuestion as Question } from '__generatedTypes__/findOneQuestion'

export type RxWritingAnswer = {
  id?: string
  drug: string
  strength: string[]
  disp: string[]
  sig: string[]
  repeat: number
}

export const EMPTY_RX_WRITING_ANSWER: RxWritingAnswer = {
  drug: '',
  strength: [],
  disp: [],
  sig: [],
  repeat: 0,
}

export const parseRxWritingAnswerHtml = (textAsHtml: string): RxWritingAnswer => {
  try {
    return JSON.parse(textAsHtml)
  } catch (error) {
    console.error('An error ocurred while trying to parse RxWritingAnswer html', error)
    return EMPTY_RX_WRITING_ANSWER
  }
}

export const convertAnswerToRxWritingAnswer = (answer?: Question['answer']): RxWritingAnswer[] =>
  answer?.map(({ id, textAsHtml }) => ({
    id,
    ...parseRxWritingAnswerHtml(textAsHtml),
  })) || []

export const serializeRxWritingAnswers = (answers?: RxWritingAnswer[]): AnswerInput[] =>
  answers?.map((rxWritingAnswer, index) => ({
    id: rxWritingAnswer.id,
    textAsHtml: JSON.stringify(omit(rxWritingAnswer, 'id')),
    isCorrect: true,
    point: 1,
    order: index,
  })) ?? []
